import { Component, forwardRef, Optional, Host, SkipSelf, Inject, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlContainer } from '@angular/forms';
import { BaseInputComponent } from './base-input.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'input-int',
    templateUrl: './input-int.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputIntComponent), multi: true }
    ]
})

export class InputIntComponent extends BaseInputComponent<number> {
    @Input() public maxLength: number = Number.MAX_SAFE_INTEGER;

    constructor(@Optional() @Host() @SkipSelf() controlContainer: ControlContainer, translateService: TranslateService) {
        super(controlContainer, translateService);
    }

    protected toInternalFormat(value: number): string {
        return value.toString();
    }

    protected toExternalFormat(value: string): number {
        return value ? parseInt(value.trim()) : null;
    }

}
